
import { defineComponent } from 'vue';

/**
 * props 전달 예시
    {
      title: '팝업 제목',
      closeFn: () => {},
      size: { w: 600, h: 700 },
      btnList: [
        { btnType: 'noBorder', btnText: "신고하기", pointYn: false, onClickFn: () => {} },
        { btnType: 'noBorder', btnText: "닫기", pointYn: false, onClickFn: () => {}}
      ],
      headerColor: '#bbb',
      footerColor: '#ccc',
      isFull?: boolean,
      isConfirm?: boolean,
      noHeader?: boolean,
      isBig?: boolean
    }
 */

// interface PopInfo {
// title: string;
// closeFn: () => unknown;
// size: { w: string; h: string };
// btnList: [
//   {
//     btnType: string;
//     btnText: string;
//     pointYn: boolean;
//     onClickFn: () => unknown;
//   }[]
// ];
// headerColor: string;
// footerColor: string;
// isFull?: boolean;
// isConfirm?: boolean;
// noHeader?: boolean;
// }

export default defineComponent({
  props: {
		pPopInfo: Object as any,
		pSelectedToggle: Function as any,
		pIsSelectedIndex: Number as any
  },
  data() {
		return {
      mScreenWidth: window.innerWidth,
			mScreenHeight: window.innerHeight,
			mIsSelectedIndex: 0,
			selectedFile: [],
			mSelectBtn: [
				{
					btnType: 'border',
					btnText: '뷰어',
					pointYn: false,
					icon: require(`@/assets/icons/banner1.png`),
					onClickFn: undefined,
				},
				{
					btnType: 'border',
					btnText: '변환',
					pointYn: false,
					icon: require(`@/assets/icons/banner2.png`),
					onClickFn: undefined,
				},
				{
					btnType: 'border',
					btnText: '필터',
					pointYn: false,
					icon: require(`@/assets/icons/banner3.png`),
					onClickFn: undefined,
				},
			],
    };
  },
  computed: {
    responsiveSize() {
      if (this.mScreenWidth >= 1290) {
        return {
          width: this.pPopInfo.size.w,
          height: this.pPopInfo.size.h,
        };
      } else if (this.pPopInfo.isFull) {
        return {
          width: '100%',
          height: '100%',
        };
      } else if (this.pPopInfo.isConfirm) {
        return {
          width: (this.mScreenWidth / 10) * 9 + 'px',
          height: (this.mScreenHeight / 10) * 4 + 'px',
        };
      } else {
        return {
          width: (this.mScreenWidth / 10) * 9 + 'px',
          height: (this.mScreenHeight / 10) * 6 + 'px',
        };
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const wrapDom: any = document.querySelector('html');
      wrapDom.style.overflow = 'hidden ';
			window.addEventListener('resize', this.onResize);
    });
  },
  beforeUnmount() {
    const wrapDom: any = document.querySelector('html');
    wrapDom.style.overflow = 'hidden auto';
		window.removeEventListener('resize', this.onResize);
	},
  methods: {
    onResize() {
      this.mScreenWidth = window.innerWidth;
    },
		// selectedToggle(index: number) {
		// 	this.mIsSelectedIndex = index
    //   this.selectedFile = []
		// 	console.log('mIsSelectedIndex', this.mIsSelectedIndex)
		// },
  },
});
